import { ItemQuestionario } from "src/app/questionario/questao/item-questionario-base";
import { TipoItemQuestionario } from "src/app/questionario/questao/model/tipo-item-questionario.enum";

export class QuestaoMultiplaescolha extends ItemQuestionario<TipoItemQuestionario> {
  options: {
    key: string,
    value: string
  }[] = [];

  constructor(options: {} = {}) {
    super(options);
    this.options = options['options'] || [];
    this.questao.tipo = TipoItemQuestionario.MULTIPLA_ESCOLHA;
  }

  getLabel(): string {
    return 'Múltipla escolha';
  }

  getMaterialIcon(): string {
    return 'check_box';
  }

  isQuestaoEstruturada(): boolean {
    return true;
  }

}
